import { GTP_BET_BUILDER_COMBINATION_TYPE } from '~Betslip/uiModes/shared/GTPBetBuilder/constants';

/**
 * Check a flag in the websoicket message for login flow
 * Two relevant use cases:
 *  - SLD dropped/reconnected (onConnect callback runs)
 *  - Post login when websocket is created (onConnect, BetslipContainer/isLoggedIn useEffect()
 * callbacks run)
 * This middleware filteres out websocket messages triggered by the BetslipContainer/isLoggedIn
 * flow to prevent duplicate messages being sent to SLD
 * This  middleware should not be needed if the SDL connection becomes persistent
 * @param {object} wsPayload websocket payload
 * @returns {object|boolean} original payload or false
 */
export const sldLoginFlowCheckMiddleware = (wsPayload) => {
    if (wsPayload.type !== GTP_BET_BUILDER_COMBINATION_TYPE) {

        return wsPayload;
    }

    if (wsPayload.isLoginFlow) {

        return false;
    }

    return wsPayload;
};
